import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo1_Bernardo } from '../../../../../utils/EN/Modals/directors';

const ModalVideoBernardo1 = () => {
  return (
    <>
      <ModalVideo
        id="bernardo-video-1"
        dataText={TextVideo1_Bernardo}
        videoSrc="https://player.vimeo.com/video/644064821?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_BERNARDO_1"
      />
    </>
  );
};

export default ModalVideoBernardo1;
